// What the phone knows about packs (C6, C7): the family's own, the catalogue the Atlas shows, how it
// can buy (Stripe on the web, Play in the Play app) and the countries it asked to hear about.
// Filled by syncOwnedPacks (data/packFiles); `owned` is kept between starts so the Map can wrap
// islands offline.
import { create } from 'zustand'
import type { CatalogueEntry } from '../domain/packs'

export interface EntitlementsResponse {
  packs: string[]
  catalogue: CatalogueEntry[]
  web: boolean
  play: boolean
  notify?: string[]
}

interface PacksState {
  owned: string[] | null
  catalogue: CatalogueEntry[]
  web: boolean
  play: boolean
  notify: string[]
  set(r: Partial<Omit<PacksState, 'set'>>): void
}

export const usePacks = create<PacksState>((set) => ({
  owned: null,
  catalogue: [],
  web: false,
  play: false,
  notify: [],
  set: (r) => set(r),
}))
